import { cn } from "@/lib/utils";

const DashboardSection = ({
  title,
  description,
  action = null,
  children,
  className,
  bodyClassName,
  titleClassName,
  testId,
}) => (
  <section
    className={cn(
      "min-w-0 rounded-xl border border-white/10 bg-white/[0.02] p-5 shadow-sm shadow-black/20 sm:p-6",
      className,
    )}
    data-testid={testId}
  >
    {(title || description || action) ? (
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          {title ? (
            <h2 className={cn("text-lg font-semibold text-white", titleClassName)}>
              {title}
            </h2>
          ) : null}
          {description ? (
            <p className="mt-1 break-words text-sm text-slate-400">{description}</p>
          ) : null}
        </div>
        {action ? <div className="w-full min-w-0 sm:w-auto">{action}</div> : null}
      </div>
    ) : null}
    <div className={cn(title || description || action ? "mt-5 min-w-0" : "min-w-0", bodyClassName)}>
      {children}
    </div>
  </section>
);

export default DashboardSection;
